export const parametersToStateMapper = {
  getInitialState: minimalInitialState => minimalInitialState,
  updateStateFromParameters: newMinimalState => newMinimalState,
  shouldIgnoreItemsStateUpdate: () => true
};